// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'
import Auth from '@/services/hatsApi/Auth'
import Service from '@/services/hatsApi/Service'
import Account from '@/services/hatsApi/Account'
import Reservation from '@/services/hatsApi/Reservation'

export default {
  login ({commit}, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      Auth.login(user).then(resp => {
        if (resp.data.success) {
          const token = resp.data.data.token
          const expires = resp.data.data.expires - 240
          const user = resp.data.data.firstName
          const accountId = resp.data.data.accountId

          let timestampRefresh = new Date()
          timestampRefresh.setSeconds(timestampRefresh.getSeconds() + 86400)
          localStorage.setItem('tokenRefreshExpiry', timestampRefresh.getTime() + '')
          let timestamp = new Date()
          timestamp.setSeconds(timestamp.getSeconds() + expires)
          localStorage.setItem('token', JSON.stringify(token))
          localStorage.setItem('tokenExpiry', timestamp.getTime() + '')
          localStorage.setItem('user', user)
          localStorage.setItem('accountId', accountId)
          axios.defaults.headers.common['auth-token'] = token

          Account.getAccount(accountId).then(accResp => {
            if (accResp.data.success) {
              const account = accResp.data.data
              commit('account', JSON.stringify(account))
              resolve(accResp)
            }
          }).catch(err => {
            localStorage.removeItem('account')
            console.log(err)
          })

          commit('auth_success', {token, user})
          resolve(resp)
        } else {
          reject(resp.data.msg)
        }
      }).catch(err => {
        commit('auth_error')
        localStorage.removeItem('token')
        localStorage.removeItem('tokenExpiry')
        localStorage.removeItem('tokenRefreshExpiry')
        localStorage.removeItem('user')
        localStorage.removeItem('accountId')
        reject(err)
      })
    })
  },
  logout ({commit}) {
    return new Promise((resolve, reject) => {
      Auth.logout().then(resp => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('tokenExpiry')
        localStorage.removeItem('tokenRefreshExpiry')
        localStorage.removeItem('user')
        delete axios.defaults.headers.common['auth-token']
      })
      resolve()
    })
  },
  refreshToken ({commit}, token) {
    return new Promise((resolve, reject) => {
      Auth.refresh(token).then(resp => {
        const expires = resp.data.data.expires - 240

        let timestamp = new Date()
        timestamp.setSeconds(timestamp.getSeconds() + expires)
        localStorage.setItem('tokenExpiry', timestamp.getTime() + '')
        resolve(resp)
      }).catch(err => {
        commit('auth_error')
        localStorage.removeItem('token')
        localStorage.removeItem('tokenExpiry')
        localStorage.removeItem('tokenRefreshExpiry')
        localStorage.removeItem('user')
        reject(err)
      })
    })
  },
  async getServiceTypes ({commit}) {
    try {
      let params = [
        {
          property: 'reservation',
          value: false
        },
        {
          property: 'reservationLine',
          value: true
        }
      ]
      let serviceTypesResponse = await Service.getServiceTypes(params)
      if (serviceTypesResponse.data.success) {
        commit('serviceTypes', serviceTypesResponse.data.data)
      }
    } catch (error) {
      console.error(error)
    }
  },
  getPrebuildTripServiceTypes ({commit}) {
    return new Promise(async (resolve, reject) => {
      try {
        let params = [
          {
            property: 'code',
            value: 'PREBUILD_TRIP'
          }
        ]
        let serviceTypesResponse = await Service.getServiceTypes(params)
        if (serviceTypesResponse.data.success) {
          // Get the first one
          commit('prebuildTrip', serviceTypesResponse.data.data[0])
          resolve(serviceTypesResponse.data.data[0])
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  getPrebuildBlockServiceTypes ({commit}) {
    return new Promise(async (resolve, reject) => {
      try {
        let params = [
          {
            property: 'code',
            value: 'PREBUILD_BLOCK'
          }
        ]
        let serviceTypesResponse = await Service.getServiceTypes(params)
        if (serviceTypesResponse.data.success) {
          // Get the first one
          commit('prebuildBlock', serviceTypesResponse.data.data[0])
          resolve(serviceTypesResponse.data.data[0])
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  getServiceCategories ({commit, dispatch, getters}) {
    return new Promise((resolve, reject) => {
      dispatch('getPrebuildTripServiceTypes').then(async () => {
        try {
          let prebuildTrip = getters.prebuildTrip
          let params = [
            {
              property: 'serviceTypeId',
              value: prebuildTrip.id
            }
          ]
          let prebuildTripResponse = await Service.getServiceCategories(params)
          if (prebuildTripResponse.data.success) {
            // Get the next category
            dispatch('getPrebuildBlockServiceTypes').then(async () => {
              let prebuildBlock = getters.prebuildBlock
              let params = [
                {
                  property: 'serviceTypeId',
                  value: prebuildBlock.id
                }
              ]
              let prebuildBlockResponse = await Service.getServiceCategories(params)
              if (prebuildBlockResponse.data.success) {
                let serviceCategories = [...prebuildTripResponse.data.data, ...prebuildBlockResponse.data.data]
                commit('serviceCategories', serviceCategories)
                resolve(serviceCategories)
              }
            })
          }
        } catch (error) {
          reject(error)
        }
      })
    })
  },
  async getReservation ({commit}, id) {
    return new Promise((resolve, reject) => {
      Reservation.getReservation(id).then(resp => {
        commit('reservation', resp.data.data)
        resolve(resp)
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js